import { render } from "./ConfirmButton.vue?vue&type=template&id=1ac366a3&scoped=true"
import script from "./ConfirmButton.vue?vue&type=script&lang=js"
export * from "./ConfirmButton.vue?vue&type=script&lang=js"

import "./ConfirmButton.vue?vue&type=style&index=0&id=1ac366a3&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac366a3"]])

export default __exports__